import React, { } from 'react';
import { RouteChildrenProps, } from 'react-router-dom';
import { Modal, message, Spin, Button, Tag, Space, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import api, { GetQuotaIntervalListParameters, DeleteQuotaIntervalParameters, GetQuotaIntervalRes } from '../../api';
import JJ_Table from '../../components/JJ_Table';
import JJ_TableItemAction from '../../components/JJ_TableItemAction';
import JJ_TableItemMoment from '../../components/JJ_TableItemMoment';
import QuotaIntervalEditAndAdd, { QuotaIntervalEditAndAddPropsType } from './QuotaIntervalEditAndAdd';
import { PlusOutlined } from '@ant-design/icons';
import { connect, ConnectedProps } from 'react-redux';
import JJ_TableItemCopyableId from '../../components/JJ_TableItemCopyableId';
import config from '../../config';
import moment from 'moment';
import { ActionUserRes } from '../../actions/ActionUser';
import { getI18nText } from '../../public';




const { confirm } = Modal;

type EditAndAddModalType = QuotaIntervalEditAndAddPropsType

interface PageState {
  isSpinLoading: boolean
  editAndAddModal: {
    show: boolean
    key: string
  } & EditAndAddModalType
  QuotaIntervalLabelListModal?: {
    show: boolean
    key: string
    QuotaIntervalId: string
  }
}
interface Props {

}


interface Page {
  tableRef?: JJ_Table<GetQuotaIntervalRes> | null

}


type PageProps = Props & ConnectedProps<typeof connector>

interface RootState {
  user: ActionUserRes

}

const mapState = (state: RootState) => ({
  user: state.user,
})

const mapDispatch = {

}

const connector = connect(
  mapState,
  mapDispatch
)

class QuotaIntervalList extends React.Component<PageProps, PageState> implements Page {

  constructor (props: Readonly<PageProps>) {
    super(props);
    this.state = {
      isSpinLoading: true,
      editAndAddModal: {
        type: 'add',
        show: false,
        key: new Date().toString(),
      }
    }
  }
  tableRef?: JJ_Table<GetQuotaIntervalRes> | null
  componentDidMount() {
    this._initData()
  }
  _initData = async () => {
    try {
      this.setState({
        isSpinLoading: true
      })
      await Promise.resolve()
      this.setState({
        isSpinLoading: false
      })
    } catch (error) {
      this.setState({
        isSpinLoading: false
      })
    }
  }


  _deleteQuotaInterval = async (params: DeleteQuotaIntervalParameters) => {
    const res = await api.DeleteQuotaInterval(params)
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }

  render() {
    return (
      <div id="QuotaIntervalList"
      >
        <Button
          type='primary'
          style={{ marginBottom: 5 }}
          onClick={() => {
            this.setState(state => ({
              editAndAddModal: {
                ...state.editAndAddModal,
                show: true,
                key: new Date().toString(),
                type: 'add',
              }
            }))
          }}
          icon={<PlusOutlined />}
        >
          {`添加配额時段`}
        </Button>

        <Modal
          maskClosable={false}
          title={this.state.editAndAddModal.type === 'edit'
            ? '編輯配额時段'
            : '新建配额時段'
          }
          visible={this.state.editAndAddModal.show}
          footer={null}
          onCancel={() => this.setState(state => ({
            editAndAddModal: { ...state.editAndAddModal, show: false }
          }))}
          width={'85%'}
        >
          <QuotaIntervalEditAndAdd
            {...this.state.editAndAddModal}
            onFinish={async (props) => {
              this.setState(state => ({
                editAndAddModal: { ...state.editAndAddModal, show: false }
              }))
              switch (props.type) {
                case 'add': {
                  message.success(`添加成功`)
                }
                  break
                case 'edit': {
                  message.success(`編輯成功`)
                }
                  break

              }

              this.tableRef && await this.tableRef.refreshData()


            }}
          />
        </Modal>



        <Spin spinning={this.state.isSpinLoading}>
          {!this.state.isSpinLoading && (
            <JJ_Table<GetQuotaIntervalRes, {
              desc: 'ascend' | 'descend'
              createRange?: [moment.Moment, moment.Moment] | null
            }>
              ref={ref => this.tableRef = ref}
              isSearchText={true}
              sourceItems={[
                {
                  type: 'select',
                  defaultValue: 'ascend',
                  key: 'desc',
                  options: [
                    {
                      value: 'ascend',
                      name: '升序',
                      disabled: false,
                    },
                    {
                      value: 'descend',
                      name: '降序',
                      disabled: false,
                    },
                  ]
                },
                {
                  type: 'rangePicker',
                  key: 'createRange',
                  span: 8,
                  props: {
                    placeholder: ['創建開始時間', '創建結束時間'],
                  }
                },
              ]}
              columns={[
                {
                  key: 'action',
                  width: 50,
                  render: (value: any, record) => {



                    return (
                      <JJ_TableItemAction
                        menus={[
                          {
                            type: 'item',
                            disabled: false,
                            key: 'edit',
                            name: '編輯',
                            onAction: () => {
                              this.setState(state => ({
                                editAndAddModal: { ...state.editAndAddModal, show: true, type: 'edit', id: record.id, key: new Date().toString() }
                              }))
                            }
                          },
                          {
                            type: 'item',
                            disabled: config.REACT_APP_DELETE_DISABLED,
                            key: 'delete',
                            name: '删除',
                            onAction: () => {
                              confirm({
                                title: `是否刪除${getI18nText(record.name, this.props.user.data.language)}`,
                                icon: <ExclamationCircleOutlined />,
                                okText: 'Yes',
                                okType: 'danger',
                                cancelText: 'No',
                                onOk: async () => {
                                  try {
                                    await this._deleteQuotaInterval({ id: record.id })
                                    this.tableRef && this.tableRef.refreshData()
                                    message.success(`${getI18nText(record.name, this.props.user.data.language)} 删除成功`)
                                  } catch (error) {
                                    message.error(`${getI18nText(record.name, this.props.user.data.language)} 删除失败 [${error.message}]`);
                                  }
                                },
                                onCancel() {
                                },
                              });
                            }
                          },
                        ]}
                      />
                    )

                  },
                },
                {
                  title: 'ID',
                  dataIndex: 'id',
                  key: 'id',
                  width: 50,
                  render: (value) => (
                    <JJ_TableItemCopyableId
                      text={value}
                    />
                  )
                },



                {
                  title: '名稱',
                  dataIndex: 'name',
                  key: 'name',
                  width: 120,
                  render: (value, record) => getI18nText(record.name, this.props.user.data.language)
                },


                {
                  title: '時段',
                  dataIndex: 'datas',
                  key: 'datas',
                  width: 120,
                  render: (value, record) => {
                    return record.datas.map((data, index) => {
                      return <div key={index}>{`${moment().day((data).weekDay).format('dddd')} ${moment(data.startTime, 'HH:mm').format('HH:mm')} - ${moment(data.endTime, 'HH:mm').format('HH:mm')}`}</div>
                    })
                  }
                },


                {
                  title: '創建時間',
                  dataIndex: 'createdAt',
                  key: 'createdAt',
                  width: 150,
                  render: (value) => (
                    <JJ_TableItemMoment
                      date={value}
                    />
                  )
                },
              ]}
              title={'配额時段列表'}
              tableProps={{

              }}
              onDataSource={async (body) => {
                const { sourceItemBody } = body
                const params: {
                  isAscend?: GetQuotaIntervalListParameters['isAscend']
                  beginAt?: GetQuotaIntervalListParameters['beginAt']
                  endAt?: GetQuotaIntervalListParameters['endAt']

                } = {}
                if (sourceItemBody) {
                  if (sourceItemBody.desc) {
                    params.isAscend = sourceItemBody.desc === 'ascend' ? true : false
                    const createRange = sourceItemBody.createRange
                    if (createRange && createRange.length === 2) {
                      const [createRangeBeginAtMoment, createRangeEndAtMoment,] = createRange
                      params.beginAt = createRangeBeginAtMoment.toISOString()
                      params.endAt = createRangeEndAtMoment.toISOString()
                    }
                  }

                }

                const res = await api.GetQuotaIntervalList({
                  ...body,
                  ...params,
                })
                if (res.kind !== 'ok') throw new Error(res.kind)
                return res.data
              }}
            />
          )}
        </Spin>

      </div>
    )
  }

}
export default connector(QuotaIntervalList)

